const cueSet1 = [
  {
          "duration": 0.571428,
          "durationTicks": 15360,
          "midi": 43,
          "name": "G2",
          "ticks": 0,
          "time": 0,
          "velocity": 0.7874015748031497
        },
        {
          "duration": 0.285714,
          "durationTicks": 7680,
          "midi": 43,
          "name": "G2",
          "ticks": 53760,
          "time": 1.9999980000000002,
          "velocity": 0.7874015748031497
        },
        {
          "duration": 0.571428,
          "durationTicks": 15360,
          "midi": 47,
          "name": "B2",
          "ticks": 61440,
          "time": 2.285712,
          "velocity": 0.7874015748031497
        },
        {
          "duration": 0.28571400000000047,
          "durationTicks": 7680,
          "midi": 47,
          "name": "B2",
          "ticks": 115200,
          "time": 4.28571,
          "velocity": 0.7874015748031497
        },
        {
          "duration": 0.571428,
          "durationTicks": 15360,
          "midi": 45,
          "name": "A2",
          "ticks": 122880,
          "time": 4.571424,
          "velocity": 0.7874015748031497
        },
        {
          "duration": 0.28571400000000047,
          "durationTicks": 7680,
          "midi": 45,
          "name": "A2",
          "ticks": 176640,
          "time": 6.571422,
          "velocity": 0.7874015748031497
        },
        {
          "duration": 0.571428,
          "durationTicks": 15360,
          "midi": 48,
          "name": "C3",
          "ticks": 184320,
          "time": 6.857136000000001,
          "velocity": 0.7874015748031497
        },
        {
          "duration": 0.28571400000000047,
          "durationTicks": 7680,
          "midi": 48,
          "name": "C3",
          "ticks": 207360,
          "time": 7.714278,
          "velocity": 0.7874015748031497
        },
        {
          "duration": 0.5714279999999992,
          "durationTicks": 15360,
          "midi": 47,
          "name": "B2",
          "ticks": 215040,
          "time": 7.999992000000001,
          "velocity": 0.7874015748031497
        },
        {
          "duration": 0.5714280000000009,
          "durationTicks": 15360,
          "midi": 45,
          "name": "A2",
          "ticks": 230400,
          "time": 8.57142,
          "velocity": 0.7874015748031497
        },
        {
          "duration": 0.5714280000000009,
          "durationTicks": 15360,
          "midi": 43,
          "name": "G2",
          "ticks": 245760,
          "time": 9.142848,
          "velocity": 0.7874015748031497
        },
        {
          "duration": 0.28571400000000047,
          "durationTicks": 7680,
          "midi": 43,
          "name": "G2",
          "ticks": 299520,
          "time": 11.142846,
          "velocity": 0.7874015748031497
        },
        {
          "duration": 0.5714280000000009,
          "durationTicks": 15360,
          "midi": 47,
          "name": "B2",
          "ticks": 307200,
          "time": 11.428560000000001,
          "velocity": 0.7874015748031497
        },
        {
          "duration": 0.28571400000000047,
          "durationTicks": 7680,
          "midi": 47,
          "name": "B2",
          "ticks": 360960,
          "time": 13.428558,
          "velocity": 0.7874015748031497
        },
        {
          "duration": 0.5714280000000009,
          "durationTicks": 15360,
          "midi": 45,
          "name": "A2",
          "ticks": 368640,
          "time": 13.714272000000001,
          "velocity": 0.7874015748031497
        },
        {
          "duration": 0.28571400000000047,
          "durationTicks": 7680,
          "midi": 45,
          "name": "A2",
          "ticks": 422400,
          "time": 15.71427,
          "velocity": 0.7874015748031497
        },
        {
          "duration": 0.5714280000000009,
          "durationTicks": 15360,
          "midi": 48,
          "name": "C3",
          "ticks": 430080,
          "time": 15.999984000000001,
          "velocity": 0.7874015748031497
        },
        {
          "duration": 0.2857139999999987,
          "durationTicks": 7680,
          "midi": 48,
          "name": "C3",
          "ticks": 453120,
          "time": 16.857126,
          "velocity": 0.7874015748031497
        },
        {
          "duration": 0.5714280000000009,
          "durationTicks": 15360,
          "midi": 47,
          "name": "B2",
          "ticks": 460800,
          "time": 17.14284,
          "velocity": 0.7874015748031497
        },
        {
          "duration": 0.5714280000000009,
          "durationTicks": 15360,
          "midi": 45,
          "name": "A2",
          "ticks": 476160,
          "time": 17.714268,
          "velocity": 0.7874015748031497
        },
        {
          "duration": 0.5714280000000009,
          "durationTicks": 15360,
          "midi": 43,
          "name": "G2",
          "ticks": 491520,
          "time": 18.285696,
          "velocity": 0.7874015748031497
        },
        {
          "duration": 0.2857139999999987,
          "durationTicks": 7680,
          "midi": 43,
          "name": "G2",
          "ticks": 545280,
          "time": 20.285694000000003,
          "velocity": 0.7874015748031497
        },
        {
          "duration": 0.5714280000000009,
          "durationTicks": 15360,
          "midi": 47,
          "name": "B2",
          "ticks": 552960,
          "time": 20.571408,
          "velocity": 0.7874015748031497
        },
        {
          "duration": 0.2857139999999987,
          "durationTicks": 7680,
          "midi": 47,
          "name": "B2",
          "ticks": 606720,
          "time": 22.571406000000003,
          "velocity": 0.7874015748031497
        },
        {
          "duration": 0.5714280000000009,
          "durationTicks": 15360,
          "midi": 45,
          "name": "A2",
          "ticks": 614400,
          "time": 22.857120000000002,
          "velocity": 0.7874015748031497
        },
        {
          "duration": 0.2857139999999987,
          "durationTicks": 7680,
          "midi": 45,
          "name": "A2",
          "ticks": 668160,
          "time": 24.857118000000003,
          "velocity": 0.7874015748031497
        },
        {
          "duration": 0.5714280000000009,
          "durationTicks": 15360,
          "midi": 48,
          "name": "C3",
          "ticks": 675840,
          "time": 25.142832000000002,
          "velocity": 0.7874015748031497
        },
        {
          "duration": 0.2857139999999987,
          "durationTicks": 7680,
          "midi": 48,
          "name": "C3",
          "ticks": 698880,
          "time": 25.999974,
          "velocity": 0.7874015748031497
        },
        {
          "duration": 0.5714280000000009,
          "durationTicks": 15360,
          "midi": 47,
          "name": "B2",
          "ticks": 706560,
          "time": 26.285688,
          "velocity": 0.7874015748031497
        },
        {
          "duration": 0.5714280000000009,
          "durationTicks": 15360,
          "midi": 45,
          "name": "A2",
          "ticks": 721920,
          "time": 26.857116,
          "velocity": 0.7874015748031497
        },
        {
          "duration": 0.5714280000000009,
          "durationTicks": 15360,
          "midi": 43,
          "name": "G2",
          "ticks": 737280,
          "time": 27.428544000000002,
          "velocity": 0.7874015748031497
        },
        {
          "duration": 0.2857139999999987,
          "durationTicks": 7680,
          "midi": 43,
          "name": "G2",
          "ticks": 791040,
          "time": 29.428542000000004,
          "velocity": 0.7874015748031497
        },
        {
          "duration": 0.5714280000000009,
          "durationTicks": 15360,
          "midi": 47,
          "name": "B2",
          "ticks": 798720,
          "time": 29.714256000000002,
          "velocity": 0.7874015748031497
        },
        {
          "duration": 0.2857139999999987,
          "durationTicks": 7680,
          "midi": 47,
          "name": "B2",
          "ticks": 852480,
          "time": 31.714254000000004,
          "velocity": 0.7874015748031497
        },
        {
          "duration": 0.5714279999999974,
          "durationTicks": 15360,
          "midi": 45,
          "name": "A2",
          "ticks": 860160,
          "time": 31.999968000000003,
          "velocity": 0.7874015748031497
        },
        {
          "duration": 0.2857139999999987,
          "durationTicks": 7680,
          "midi": 45,
          "name": "A2",
          "ticks": 913920,
          "time": 33.999966,
          "velocity": 0.7874015748031497
        },
        {
          "duration": 0.5714280000000045,
          "durationTicks": 15360,
          "midi": 48,
          "name": "C3",
          "ticks": 921600,
          "time": 34.28568,
          "velocity": 0.7874015748031497
        },
        {
          "duration": 0.2857139999999987,
          "durationTicks": 7680,
          "midi": 48,
          "name": "C3",
          "ticks": 944640,
          "time": 35.142822,
          "velocity": 0.7874015748031497
        },
        {
          "duration": 0.5714280000000045,
          "durationTicks": 15360,
          "midi": 47,
          "name": "B2",
          "ticks": 952320,
          "time": 35.428536,
          "velocity": 0.7874015748031497
        },
        {
          "duration": 0.5714279999999974,
          "durationTicks": 15360,
          "midi": 45,
          "name": "A2",
          "ticks": 967680,
          "time": 35.999964000000006,
          "velocity": 0.7874015748031497
        },
        {
          "duration": 0.5714279999999974,
          "durationTicks": 15360,
          "midi": 43,
          "name": "G2",
          "ticks": 983040,
          "time": 36.571392,
          "velocity": 0.7874015748031497
        },
        {
          "duration": 0.2857140000000058,
          "durationTicks": 7680,
          "midi": 43,
          "name": "G2",
          "ticks": 1036800,
          "time": 38.57139,
          "velocity": 0.7874015748031497
        },
        {
          "duration": 0.5714279999999974,
          "durationTicks": 15360,
          "midi": 47,
          "name": "B2",
          "ticks": 1044480,
          "time": 38.85710400000001,
          "velocity": 0.7874015748031497
        },
        {
          "duration": 0.2857139999999987,
          "durationTicks": 7680,
          "midi": 47,
          "name": "B2",
          "ticks": 1098240,
          "time": 40.857102000000005,
          "velocity": 0.7874015748031497
        },
        {
          "duration": 0.5714279999999974,
          "durationTicks": 15360,
          "midi": 45,
          "name": "A2",
          "ticks": 1105920,
          "time": 41.142816,
          "velocity": 0.7874015748031497
        },
        {
          "duration": 0.2857139999999987,
          "durationTicks": 7680,
          "midi": 45,
          "name": "A2",
          "ticks": 1159680,
          "time": 43.142814,
          "velocity": 0.7874015748031497
        },
        {
          "duration": 0.5714280000000045,
          "durationTicks": 15360,
          "midi": 48,
          "name": "C3",
          "ticks": 1167360,
          "time": 43.428528,
          "velocity": 0.7874015748031497
        },
        {
          "duration": 0.2857139999999987,
          "durationTicks": 7680,
          "midi": 48,
          "name": "C3",
          "ticks": 1190400,
          "time": 44.28567,
          "velocity": 0.7874015748031497
        },
        {
          "duration": 0.5714280000000045,
          "durationTicks": 15360,
          "midi": 47,
          "name": "B2",
          "ticks": 1198080,
          "time": 44.571384,
          "velocity": 0.7874015748031497
        },
        {
          "duration": 0.5714279999999974,
          "durationTicks": 15360,
          "midi": 45,
          "name": "A2",
          "ticks": 1213440,
          "time": 45.142812000000006,
          "velocity": 0.7874015748031497
        },
        {
          "duration": 0.5714279999999974,
          "durationTicks": 15360,
          "midi": 43,
          "name": "G2",
          "ticks": 1228800,
          "time": 45.714240000000004,
          "velocity": 0.7874015748031497
        },
        {
          "duration": 0.2857140000000058,
          "durationTicks": 7680,
          "midi": 43,
          "name": "G2",
          "ticks": 1282560,
          "time": 47.714238,
          "velocity": 0.7874015748031497
        },
        {
          "duration": 0.5714279999999974,
          "durationTicks": 15360,
          "midi": 47,
          "name": "B2",
          "ticks": 1290240,
          "time": 47.99995200000001,
          "velocity": 0.7874015748031497
        },
        {
          "duration": 0.2857139999999987,
          "durationTicks": 7680,
          "midi": 47,
          "name": "B2",
          "ticks": 1344000,
          "time": 49.999950000000005,
          "velocity": 0.7874015748031497
        },
        {
          "duration": 0.5714279999999974,
          "durationTicks": 15360,
          "midi": 45,
          "name": "A2",
          "ticks": 1351680,
          "time": 50.285664000000004,
          "velocity": 0.7874015748031497
        },
        {
          "duration": 0.2857139999999987,
          "durationTicks": 7680,
          "midi": 45,
          "name": "A2",
          "ticks": 1405440,
          "time": 52.285662,
          "velocity": 0.7874015748031497
        },
        {
          "duration": 0.5714280000000045,
          "durationTicks": 15360,
          "midi": 48,
          "name": "C3",
          "ticks": 1413120,
          "time": 52.571376,
          "velocity": 0.7874015748031497
        },
        {
          "duration": 0.2857139999999987,
          "durationTicks": 7680,
          "midi": 48,
          "name": "C3",
          "ticks": 1436160,
          "time": 53.428518000000004,
          "velocity": 0.7874015748031497
        },
        {
          "duration": 0.5714280000000045,
          "durationTicks": 15360,
          "midi": 47,
          "name": "B2",
          "ticks": 1443840,
          "time": 53.714232,
          "velocity": 0.7874015748031497
        },
        {
          "duration": 0.5714279999999974,
          "durationTicks": 15360,
          "midi": 45,
          "name": "A2",
          "ticks": 1459200,
          "time": 54.28566000000001,
          "velocity": 0.7874015748031497
        },
        {
          "duration": 0.5714279999999974,
          "durationTicks": 15360,
          "midi": 43,
          "name": "G2",
          "ticks": 1474560,
          "time": 54.857088000000005,
          "velocity": 0.7874015748031497
        }
];

export default cueSet1;
